import { useContext } from 'react'
import { LayoutContext } from '../../context/layout-context'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'

export const useOrderMobile = () => {
  const {
    layoutState: { isOrderDetailsMobileShow },
  } = useContext(LayoutContext)

  const checkoutInfo = queryClient.getQueryData([
    'checkout-info',
  ]) as CheckoutInfo | undefined

  return {
    order: checkoutInfo?.payment_link?.additional_data?.order ?? null,
    isOrderDetailsMobileShow,
  }
}
